import React from 'react';
import { Link } from 'react-router';
import { getRelativePath } from 'base/shared/Utils';
import {
  CardWrapper,
  CardImage,
  CardContent,
  Price,
  PropertyType,
  PriceRow,
  Expenses,
  RoomCardLink,
  PriceLabel,
  ExpensesLabel,
  PriceColumn,
  ExpensesColumn,
  FlatDescription,
  CityColumn,
  CityLabel,
  City,
} from './styled-components';

const RoomCard = ({ image, subtitle, flatDescription, priceText, url, city }) => {
  const linkUrl = getRelativePath(url);

  return (
    <RoomCardLink as={Link} data-qa="room-card-link" target="_blank" to={linkUrl}>
      <CardWrapper>
        <CardImage image={image} />
        <CardContent>
          <PropertyType>{subtitle}</PropertyType>
          <FlatDescription>{flatDescription}</FlatDescription>
          <PriceRow>
            <PriceColumn>
              <PriceLabel>Precio</PriceLabel>
              <Price>{priceText}</Price>
            </PriceColumn>
            <ExpensesColumn>
              <ExpensesLabel>Gastos</ExpensesLabel>
              <Expenses>Incluidos</Expenses>
            </ExpensesColumn>
            <CityColumn>
              <CityLabel>Ciudad</CityLabel>
              <City>{city}</City>
            </CityColumn>
          </PriceRow>
        </CardContent>
      </CardWrapper>
    </RoomCardLink>
  );
};

export default RoomCard;
